import { AuthService } from "./../../shared/services/auth.service";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AccountService } from "./../../shared/account/account.service";
import * as firebase from "firebase/app";
import { AngularFireAuth } from "angularfire2/auth";
import { BackendService } from "../../shared/services/backend.service";
import { LoaderService } from "../../shared/services/loader.service";
import { Subscription } from "rxjs/Subscription";
import { Constants } from "../../helper/constants";
import { NotificationService } from "../../shared/services/notification.service";
import { CommunityService } from "../../shared/services/community/community.service";
import { BehaviorSubject } from "rxjs/BehaviorSubject";

@Component({
  selector: "app-side-bar",
  templateUrl: "./side-bar.component.html",
  styleUrls: ["./side-bar.component.css"]
})
export class SideBarComponent implements OnInit, OnDestroy {
  isCollapsed = false;
  collapsedNav = false;
  private userId: string;
  private community: any;
  notDashboard = false;
  profileData;
  activeRole;
  roleSubscription: Subscription;
  activeRouteIndex: any;
  routeSubscription: Subscription;
  communitySubscription: Subscription;
  communityManager: boolean;
  unreadNotificationsCount: number;
  communities = {};
  isAdmin: boolean;
  communityId: string;
  totalCount: BehaviorSubject<number> = new BehaviorSubject(0);

  private authInstance: AngularFireAuth;
  authState: firebase.User | null;

  /**
   *
   * @param {AuthService} authService
   * @param {AccountService} accountService
   * @param {Router} router
   * @param {LoaderService} loaderService
   * @param {NotificationService} notificationService
   */
  constructor(
    private authService: AuthService,
    private accountService: AccountService,
    private router: Router,
    private loaderService: LoaderService,
    private notificationService: NotificationService,
    private communityService: CommunityService
  ) {
    this.authInstance = this.authService.getAngularFireAuthInstance();
    this.authState = this.authService.getAuthState();
    this.activeRouteIndex = 0;
    this.userId = BackendService.generateUserId(this.authState.email);
  }

  ngOnInit(): void {
    this.loaderService.startLoader();
    this.communitySubscription = this.communityService.getCommunities().subscribe(communities => {
      communities.forEach((community: any) => {
        this.communities[community.id] = community.name;
      });
      this.getUserAccounts();
    });
    this.generateActiveRouteIndex();
    this.loaderService.stopLoader();
  }

  ngOnDestroy(): void {
    if (this.roleSubscription === undefined) {
      this.roleSubscription.unsubscribe();
    }

    if (this.communitySubscription === undefined) {
      this.communitySubscription.unsubscribe();
    }
  }

  /**
   * @description sign out already authenticated user
   * @returns void
   */
  signOut(deactivated?: boolean): void {
    let param;
    let route;
    if (deactivated) {
      param = { deactivated: "true" };
      route = ["/account/login", param];
    } else {
      route = ["/account/login"];
    }
    this.authInstance.auth.signOut().then(res => this.router.navigate(route));
  }

  toggleCollapse(): void {
    this.collapsedNav = !this.collapsedNav;
  }

  switchRole(index): void {
    window.open(`dashboard/r/${index}`, "_blank");
    this.isCollapsed = true;
  }

  private generateActiveRouteIndex(): void {
    this.activeRouteIndex = this.router.url.indexOf("/r/") + 3;
    this.activeRouteIndex = parseInt(this.router.url.charAt(this.activeRouteIndex), 10);
  }

  private getUserAccounts(): void {
    this.roleSubscription = this.accountService.getProfile(this.userId).subscribe((profile: any) => {
      const profileComm = profile.roles[this.activeRouteIndex];
      const activeRole = profileComm.role;
      this.communityId = profileComm.communityId;
      this.getNotificationCounts();
      this.isAdmin = (activeRole === Constants.USER_TYPE_ADMIN) ? true : false;
      if (profile.wasAdmin && profile.roles.length === 0) {
        this.signOut(true);

        return;
      }

      profile.roles.forEach((role: any) => {
        if (role.communityId) {
          role.communityName = this.communities[role.communityId];
        }
      });
      this.profileData = profile;
      this.activeRole = profile.roles[this.activeRouteIndex];
      this.communityManager = this.activeRole.role === Constants.USER_TYPE_COMMUNITY_MANAGER;

      this.communityService.getCommunityById(this.activeRole.communityId).subscribe(community => {
        this.community = community;
        BackendService.setActiveCommunity(this.community);
      });
    });
  }

  getNotificationCounts(): void {
    const promise = new Promise<any>(resolve => {
      this.notificationService.
        getNotifications(this.communityId, this.userId).
        subscribe(data => {
          if (data) {
            const notifications = data.filter(notification => !notification.isRead);
            resolve(notifications.length);
          } else {
            resolve(0);
          }
        }
        );
    });

    promise.then(unreadCount => this.totalCount.next(unreadCount));
  }

}



// WEBPACK FOOTER //
// ./src/app/layout/side-bar/side-bar.component.ts